import { productConstants, ANCILLARY_BUNDLE } from '@eti/products';
import type { ExtraProductSelectionInput } from '@eti/schema-types';

type ExtraProduct = {
  getGraphQlSelection: (params: {
    state: { form: { [key: string]: any } };
    form: string;
    travelerIds?: string[];
  }) => ExtraProductSelectionInput | null;
  getDBFGraphQlSelection?: (params: {
    state: { form: { [key: string]: any } };
    form: string;
    travelerIds?: string[];
  }) => ExtraProductSelectionInput | null;
};

const extraProducts = [
  ...Object.values({
    ANCILLARY_BUNDLE,
  }),
  ...Object.values(productConstants),
] as ExtraProduct[];

type GetGraphQlSelectionForAllProducts = (params: {
  form?: string;
  state?: { form: { [key: string]: any } };
  values?: { [key: string]: any };
  travelerIds?: (string | null | undefined)[];
}) => ExtraProductSelectionInput[];

const getGraphQlSelectionForAllProducts: GetGraphQlSelectionForAllProducts = ({
  form = 'extraProducts',
  state,
  values,
}) =>
  extraProducts
    .map(({ getGraphQlSelection }) =>
      getGraphQlSelection({ state: state || { form: { [form]: { values } } }, form }),
    )
    .filter(Boolean) as ExtraProductSelectionInput[];

export const getDBFGraphQlSelectionForAllProducts: GetGraphQlSelectionForAllProducts = ({
  form = 'extraProducts',
  state,
  values,
}) =>
  extraProducts
    .map(({ getDBFGraphQlSelection, getGraphQlSelection }) =>
      getDBFGraphQlSelection
        ? getDBFGraphQlSelection({ state: state || { form: { [form]: { values } } }, form })
        : getGraphQlSelection({ state: state || { form: { [form]: { values } } }, form }),
    )
    .filter(Boolean) as ExtraProductSelectionInput[];

export default getGraphQlSelectionForAllProducts;
